export const API_PATHS = {
  CLIENT_BUSINESS: '/v1/client/business',
  CLIENT_PROVIDERS: '/v1/client/providers',
  CLIENT_SERVICES: '/v1/client/services',
  CLIENT_SLOTS: '/v1/client/slots',
  CLIENT_SLOTS_NEXT: '/v1/client/slots/next-available',
  CLIENT_BOOKINGS: '/v1/client/bookings',
  clientBookingsTab: (tab: 'active' | 'history', cursor?: string, size?: number) => {
    const params = new URLSearchParams({ tab, size: String(size ?? 20) });
    if (cursor) params.set('cursor', cursor);
    return `/v1/client/bookings?${params.toString()}`;
  },
  clientBookingByUuid: (uuid: string) => `/v1/client/bookings/${uuid}`,
  CLIENT_HOME: '/v1/client/home',
  clientBookingCancel: (uuid: string) => `/v1/client/bookings/${uuid}/cancel` as const,
  CLIENT_PROFILE: '/v1/client/profile',
  CLIENT_LANGUAGE_UPDATE: '/v1/client/me/language',
  PROVIDER_LANGUAGE_UPDATE: '/v1/provider/me/language',
  OWNER_LANGUAGE_UPDATE: '/v1/owner/me/language',
  userMeUpdate: (tenantId: number) => `/v1/tenants/${tenantId}/users/me` as const,
} as const;
